import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/447803174495"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 hover:shadow-xl transition-all duration-300"
      aria-label="Contact us on WhatsApp"
      data-testid="whatsapp-button"
    >
      <MessageCircle className="w-6 h-6" fill="white" />
    </a>
  );
};

export default WhatsAppButton;
